module.exports = __webpack_public_path__ + "img/xianindex.fb2726e8.jpg";